module.exports = __webpack_public_path__ + "img/mobile-header-global.abfde29b.jpg";